import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Dialog, DialogActions, DialogTitle,
} from '@mui/material';

class ConfirmDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ width: '400px' }}>{this.props.message}</DialogTitle>
        <DialogActions>
          <Button
            onClick={(event) => {
              this.props.onClose(event);
              this.props.onSubmit();
            }}
            color="primary"
            autoFocus
          >
            OK
          </Button>
          <Button onClick={this.props.onClose} color="primary" autoFocus>
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ConfirmDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default ConfirmDialog;
